module.exports = __webpack_public_path__ + "static/media/10-6.c4d8bbb0.mp3";